import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CreateAccountExternalSystemRequest } from '@core/generated/openapi';
import { AccountUsersService } from '@services/account-users/account-users.service';
import {
    FormBuilder,
    FormControl,
    FormGroup,
    ReactiveFormsModule,
} from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { NotificationServiceUP } from '@services/notifications/notification-service-u-p.service';
import {
    ButtonComponent,
    ButtonType,
    DialogComponent,
    FormComponent,
    InputComponent,
    LoadingOverlayDirective,
} from '@rcp/common-web';
@UntilDestroy()
@Component({
    selector: 'rcp-oup-reset-user-password-dialog',
    templateUrl: './reset-user-password-dialog.component.html',
    styleUrls: ['./reset-user-password-dialog.component.scss'],
    imports: [
        ReactiveFormsModule,
        ButtonComponent,
        DialogComponent,
        FormComponent,
        InputComponent,
        LoadingOverlayDirective,
    ],
    standalone: true,
})
export class ResetUserPasswordDialogComponent implements OnInit {
    formGroup: FormGroup;
    isSubmitting: boolean = false;

    constructor(
        private dialogRef: MatDialogRef<CreateAccountExternalSystemRequest.TypeEnum>,
        private accountUserService: AccountUsersService,
        private formBuilder: FormBuilder,
        private notificationService: NotificationServiceUP,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {}

    ngOnInit(): void {
        this.formGroup = this.formBuilder.group({
            newPassword: new FormControl('OneSpot1234!'),
            applicationUserId: new FormControl(this.data.id),
        });
    }

    closeDialog(result?: any) {
        this.dialogRef.close(result);
    }

    cancel() {
        this.closeDialog();
    }

    submit() {
        this.isSubmitting = true;
        this.accountUserService
            .resetPassword(this.formGroup)
            .pipe(untilDestroyed(this))
            .subscribe({
                next: (result) => {
                    this.notificationService.showSuccessMessage(
                        'Password Reset',
                        'The password was successfully reset.',
                    );
                    this.isSubmitting = false;
                    this.closeDialog();
                },
                error: (error) => {
                    this.isSubmitting = false;
                    console.error(error);
                    this.notificationService.showError(
                        'Error resetting user password.',
                        error.error,
                    );
                    this.closeDialog();
                },
            });
    }

    protected readonly ButtonType = ButtonType;
}
